import { Series } from "devextreme-react/chart";
import _PieChart from "devextreme-react/pie-chart";
// Vite 8 CJS interop: with "type": "module", default import may resolve to module.exports (namespace object)
const PieChart = ((_PieChart as unknown as Record<string, unknown>)["default"] ?? _PieChart) as typeof _PieChart;
import { useCallback } from "react";
import { getBasicLegend } from "./utils/getBasicLegend.ts";
import { getBasicSerieLabel } from "./utils/getBasicSerieLabel.ts";
import { getThickness } from "./getThickness.ts";
import { ChartCore } from "./ChartCore.tsx";
import type { ChartProps } from "./ChartProps.ts";
import formatArgumentLabel from "./utils/argumentFormat.ts";

export default function Doughnut(props: ChartProps) {
  const updateRef = useCallback(
    (ref: InstanceType<typeof _PieChart>) => {
      props.exportFunc(ref?.instance.exportTo.bind(ref.instance));
    },
    [props]
  );
  const renderSeries = () => {
    const argument = props.args[0];
    if (argument === undefined) return <></>;
    return props.values.map((value) => {
      return (
        <Series
          key={value.config.guid}
          argumentField={argument.meta.name}
          valueField={value.config.guid}
          name={value.config.guid}
          label={getBasicSerieLabel(value.config.guid, props.settings, props.data)}
        ></Series>
      );
    });
  };

  return (
    <ChartCore {...props}>
      <PieChart
        ref={updateRef}
        dataSource={props.dataSource}
        type="doughnut"
        legend={{
          ...getBasicLegend(props.settings),
          customizeText: ({ pointName }: { pointName?: string }) =>
            formatArgumentLabel(props.args, pointName, props.data),
        }}
        innerRadius={getThickness(props.settings)}
      >
        {renderSeries()}
      </PieChart>
    </ChartCore>
  );
}
